import React, { Component } from "react";
import { getMessage } from "CONFIG/i18n";

import logo from "../../Assets/Images/img_signin_bg_logo.webp";

import "./style.less"
export default class SSOAuthenticated extends Component {
  render() {
    return (
      <div className="ssoauthenticated">
        <div className="logoImage">
          <img src={logo} />
        </div>
        <div className="wrap">
          <div className="logo">
            <h2>{getMessage("SSO_AUTH_SUCCESS_1")}</h2>
            <p> {getMessage("SSO_AUTH_SUCCESS_2")}</p>
          </div>
        </div>
      </div>
    )
  }
}